import React from 'react';
export const StorySection = () => {
  return <section className="w-full bg-white py-8 px-4" data-id="element-366">
      <div className="max-w-4xl mx-auto" data-id="element-367">
        <div className="bg-blue-50 p-6 rounded-lg mb-8" data-id="element-368">
          <p className="text-gray-700 italic mb-4" data-id="element-369">
            "Si seulement j'avais su que ces engourdissements nocturnes étaient
            un signal d'alarme," me répète-t-il encore aujourd'hui dans mon
            bureau.
          </p>
          <p className="text-gray-700 mb-4" data-id="element-370">
            En 20 ans de pratique comme diabétologue à l'Hôpital Notre-Dame,
            j'ai vu cette tragédie se répéter des centaines de fois.
          </p>
          <p className="text-gray-700 mb-4" data-id="element-371">
            Au Québec, 1 diabétique sur 4 subira une amputation dans les 10 ans.
            85% de ces amputations commencent par des engourdissements nocturnes
            que les patients ignorent, pensant que "c'est normal avec l'âge."
          </p>
          <p className="text-gray-800 font-bold text-lg" data-id="element-372">
            Ce n'est PAS normal. Et aujourd'hui, je vais vous expliquer
            pourquoi.
          </p>
        </div>
      </div>
    </section>;
};